import Card, { CardTitle } from "components/ProfileCards/Card";

import React, { useState } from "react";
import styled from "styled-components";
import { COLORS, BREAKPOINT } from "utils/styles";
import IconButton from "components/IconButton";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";

const Content = styled.div`
  width: 100%;
  text-align: center;
  position: relative;

  img {
    width: 100%;
    max-width: 888px;
  }
`;

const Text = styled.span.attrs({ className: "mabry-medium" })`
  font-size: 4rem;
  colors: ${COLORS.DARKEST_GRAY};
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  top: -1rem;
  left: 0;
  bottom: 0;
  right: 0;
  line-height: 1.2;
  @media ${BREAKPOINT.M} {
    font-size: 2.5rem;
  }
`;

const ZoomButton = styled(IconButton)`
  margin-right: 35px;
  margin-top: 15px;
`;

const ModalContentWrapper = styled.div`
  max-height: 80vh;
  overflow: scroll;
`;

const ModalImage = styled.img`
  width: 1800px;
`;

const Footnote = styled.div`
  text-align: left;
`;

function GraphicCard({ title, imageAlt, imageUrl, text, footnote }) {
  const [showModal, setShowModal] = useState(false);
  const renderZoomIcon = () => {
    return (
      <OverlayTrigger
        key="bottom"
        placement="bottom"
        overlay={<Tooltip id={`tooltip-${"bottom"}`}>Click To Zoom</Tooltip>}
      >
        <ZoomButton
          onClick={() => {
            setShowModal(true);
          }}
        >
          <i className="material-icons-round md-dark md-18">zoom_out_map</i>
        </ZoomButton>
      </OverlayTrigger>
    );
  };
  const renderModalContent = () => {
    return (
      <ModalContentWrapper>
        <ModalImage src={imageUrl} alt={imageAlt} />
      </ModalContentWrapper>
    );
  };

  return (
    <Card>
      <Content>
        <img src={imageUrl} alt={imageAlt} />
        {text ? <Text>{text}</Text> : null}
      </Content>
      <Modal
        centered
        size="lg"
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      >
        <Modal.Header closeButton>{title}</Modal.Header>
        <Modal.Body>{renderModalContent()}</Modal.Body>
      </Modal>
      <Footnote>
        {renderZoomIcon()}
        <small>{footnote}</small>
      </Footnote>
    </Card>
  );
}

export default GraphicCard;
